module.exports = __webpack_public_path__ + "img/Believers-Church-Seminary-and-School.b9a1d800.jpg";